import { JSONSchema7 } from 'json-schema';
import { customSchemas, types as commonTypes } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import BarChart from './BarChart';

const schema: JSONSchema7 = {
    title: 'Bar Chart',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        chartTitles: headingsSchema,
        dataKey: {
            type: 'string',
            title: 'Data Key',
            default: '',
        },
        ...customSchemas.highchartOptionsSchema.HighchartOptionsSchema.schema(),
        paletteId: {
            type: 'string',
            title: 'Palette ID',
            default: 'pieChartPalette',
        },
        useManualBarWidthPadding: {
            type: 'boolean',
            title: 'Apply manual bar width and padding',
            default: false,
        },
        limitYAxisRangeToData: {
            type: 'boolean',
            title: 'Limit Y Axis Range to Data',
            default: false,
        },
        formatTo: {
            type: 'string',
            title: 'Format To (e.g. decMax2)',
            default: '',
        },
        showPlotLines: {
            type: 'boolean',
            enum: [true, false],
            title: 'Enable Plot Lines',
            default: false,
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        showPlotLines: {
            oneOf: [
                {
                    properties: {
                        showPlotLines: { enum: [true] },
                        plotLineColor: {
                            type: 'string',
                            title: 'Plot Line Color',
                            default: '#D3D3D3',
                        },
                        plotLineWidth: {
                            type: 'string',
                            title: 'Plot Line Width',
                            default: '1',
                        },
                        plotLineValue: {
                            type: 'string',
                            title: 'Plot Line Value added to index',
                            default: '0.3',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'paletteId',
            'chartTitles',
            'dataKey',
            'options',
            'formatTo',
            'useManualBarWidthPadding',
            'limitYAxisRangeToData',
            'showPlotLines',
            'plotLineColor',
            'plotLineWidth',
            'plotLineValue',
        ],
        Accessibility: ['disableTabStaticData'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    chartTitles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    paletteId: {
        'ui:widget': 'PaletteSelect',
    },
    dataKey: {
        'ui:widget': 'CustomTextInput',
    },
    ...customSchemas.highchartOptionsSchema.HighchartOptionsSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    useManualBarWidthPadding: {
        'ui:widget': 'CustomCheckbox',
    },
    limitYAxisRangeToData: {
        'ui:widget': 'CustomCheckbox',
    },
    formatTo: {
        'ui:widget': 'CustomTextInput',
    },
    showPlotLines: {
        'ui:widget': 'CustomCheckbox',
    },
    plotLineColor: {
        'ui:widget': 'CustomTextInput',
    },
    plotLineWidth: {
        'ui:widget': 'CustomTextInput',
    },
    plotLineValue: {
        'ui:widget': 'CustomTextInput',
    },
    disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
};

const BarChartWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: BarChart,
    id: 'BarChart',
    group: 'charts',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default BarChartWidget;
